import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { FormikProps } from "formik";
import React from "react";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { useComponentTexts } from "Store/texts/hooks";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";

interface FormPropsHouseProduct {
  addContentsInsurance: BooleanFormType;
}

interface Props<T extends FormPropsHouseProduct = FormPropsHouseProduct> {
  formProps: FormikProps<T>;
  lang: TextLanguage;
  name: string;
  handleContentsRadio?: (value: BooleanFormType) => void;
}

export const AddContentsInsurance = ({
  formProps,
  lang,
  name,
  handleContentsRadio,
}: Props): React.ReactElement => {
  const [{ formComponentsHouseProducts }] = useComponentTexts();
  const { addContentsInsurance } = formComponentsHouseProducts;

  return (
    <RadioButtonTrueFalse
      name={name}
      id={name}
      label={addContentsInsurance.label[lang]}
      options={[
        {
          label: addContentsInsurance.options.yes[lang],
          value: true,
          id: `${name}-yes`,
        },
        {
          label: addContentsInsurance.options.no[lang],
          value: false,
          id: `${name}-no`,
        },
      ]}
      direction="vertical"
      error={getError(name, formProps)}
      onChange={(e) => {
        handleContentsRadio?.(e?.target.value as BooleanFormType);
      }}
    />
  );
};
